<!--<div class="ui-grid-row" *ngFor="let myField of fields">
<input class="sem-text-box" type="text" (input)="onTextChange($event.target.value)" [(ngModel)]="model[myField.name]" />
</div>-->

@if ((checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true)) {
  <div class="inline-search-wrapper" (click)="addToInlineSearchProps({value:value})"></div>
}

@if (isActiveUrl) {
  <div class="active-url-textbox" (click)="redirectToActiveUrl(value)">
    <span class="sem-text-box active-url-textbox-valueholder">{{value}}</span>
  </div>
}

<div *ngIf="!isHiddenValue && !historyAutocomplete && !isCurrencyInput && !isNumberInput && !isPasswordInput && !isActiveUrl && !isIntegerInput && !isAlphaInput"
  class="copy-icon-input-wrapper"
  [class.has-copy-icon]="showCopyIconOnReadOnly && (checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true)">
  <input [placeholder]="checkPlaceholder()"
  class="sem-text-box" type="text"
  [semSpellcheck]="spellCheck" [scLanguage]="spellCheckLanguage" [scClassType]="spellCheckClassType" [scField]="spellCheckField"
  [disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true"
  (input)="onTextChange($event.target.value)"
  [(ngModel)]="value"
  [maxlength]="maxLengthInteger"
  [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }"/>
  <button *ngIf="showCopyIconOnReadOnly && (checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true) && value"
          type="button"
          class="copy-icon-btn-inside"
          (click)="$event.stopPropagation(); copyValueToClipboard()"
          [title]="copied ? 'Kopirano' : 'Kopiraj'">
    <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
  </button>
</div>


@if (!isHiddenValue && isPasswordInput && isActiveUrl == false) {
  <input [placeholder]="checkPlaceholder()"
    class="sem-text-box" type="password"
    [disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true"
    (input)="onTextChange($event.target.value)"
    [(ngModel)]="value"
    [maxlength]="maxLengthInteger"
    [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }"/>
}

<!-- FAKE ŠIFRANT: free-text field with history autocomplete (suggests previously-entered values) -->
@if (!isHiddenValue && historyAutocomplete && isCurrencyInput == false && isNumberInput == false && isPasswordInput == false && isActiveUrl == false && isIntegerInput == false) {
  <input [placeholder]="checkPlaceholder()"
    class="sem-text-box" type="text"
    [disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true"
    (input)="onTextChange($event.target.value)"
    (focus)="onHistoryFocus()"
    (blur)="onHistoryBlur()"
    [(ngModel)]="value"
    [matAutocomplete]="histAuto"
    [maxlength]="maxLengthInteger"
    [ngClass]="{ 'is-invalid': (form?.submitted && getName() != null) || lockError, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }"/>
  <mat-autocomplete #histAuto="matAutocomplete" [panelWidth]="'auto'" (optionSelected)="onHistorySelected($event.option.value)">
    @for (suggestion of historySuggestions; track suggestion) {
      <mat-option [value]="suggestion">{{ suggestion }}</mat-option>
    }
  </mat-autocomplete>
  @if (lockError) {
    <span class="sem-lock-error" style="color:#d32f2f; font-size:12px; display:block; margin-top:2px;">
      {{ translationsService.translate('galis_js_fake_sifrant_lock_hint') }}
    </span>
  }
}


<!-- ALPHA INPUT -->
<input *ngIf="!isHiddenValue && isAlphaInput && isActiveUrl == false" [placeholder]="checkPlaceholder()" #alphaInput
class="sem-text-box" type="text"
[disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true"
(input)="onTextChange($event.target.value)"
[(ngModel)]="value"
[maxlength]="maxLengthInteger"
[ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }"/>

<!-- NUMBER INPUT-->
<div *ngIf="!isHiddenValue && isNumberInput && isActiveUrl == false"
  class="copy-icon-input-wrapper"
  [class.has-copy-icon]="showCopyIconOnReadOnly && (checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true)">
  <input [placeholder]="checkPlaceholder()" #numInput NumbersOnly
  [allowDecimals]="true"
  [allowSign]="true"
  [acceptDot]="acceptDotDecimal"
  (wheel)="$event.preventDefault()"
  [maxlength]="maxLengthInteger"
  class="sem-text-box" type="text"
  [disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true"
  [ngModel]="numberDisplayValue"
  (ngModelChange)="onNumberModelChange($event)"
  [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }"/>
  <button *ngIf="showCopyIconOnReadOnly && (checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true) && value"
          type="button"
          class="copy-icon-btn-inside"
          (click)="$event.stopPropagation(); copyDisplayedValue()"
          [title]="copied ? 'Kopirano' : 'Kopiraj'">
    <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
  </button>
</div>

<div *ngIf="!isHiddenValue && isIntegerInput"
  class="copy-icon-input-wrapper"
  [class.has-copy-icon]="showCopyIconOnReadOnly && (checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true)">
  <input [placeholder]="checkPlaceholder()" #intInput
  class="sem-text-box" type="text"
  [disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true"
  (input)="onTextChange($event.target.value)"
  [(ngModel)]="value"
  [maxlength]="maxLengthInteger"
  [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }"/>
  <button *ngIf="showCopyIconOnReadOnly && (checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true) && value"
          type="button"
          class="copy-icon-btn-inside"
          (click)="$event.stopPropagation(); copyValueToClipboard()"
          [title]="copied ? 'Kopirano' : 'Kopiraj'">
    <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
  </button>
</div>


<!-- CURRENCY INPUT-->
<div *ngIf="!isHiddenValue && isCurrencyInput && isActiveUrl == false"
  class="copy-icon-input-wrapper"
  [class.has-copy-icon]="showCopyIconOnReadOnly && (checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true)">
  <input [placeholder]="checkPlaceholder()" #numInput [currencyMask]="{align: 'left', allowNegative: false, precision:2, min :0, inputMode : Natural, prefix:'', suffix : ' '+currencySign, thousands: '.', decimal: ',' }"
  min="0"
  class="sem-text-box" type="text"
  [disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true"
  (ngModelChange)="onTextChange($event)"
  [(ngModel)]="value"
  [maxlength]="maxLengthInteger"
  [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }"/>
  <button *ngIf="showCopyIconOnReadOnly && (checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true) && value"
          type="button"
          class="copy-icon-btn-inside"
          (click)="$event.stopPropagation(); copyDisplayedValue()"
          [title]="copied ? 'Kopirano' : 'Kopiraj'">
    <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
  </button>
</div>

<!-- HIDDEN VALUE DISPLAY with reveal icon inside -->
@if (isHiddenValue) {
  <div class="hidden-value-input-wrapper">
    <input class="sem-text-box disabled-field hidden-input-with-icon" type="text"
      [disabled]="true"
      readonly
      value="*************" />
      <button type="button"
        class="reveal-icon-btn-inside"
        (click)="onRevealHiddenValue()"
        [ngClass]="{ 'hidden-icon': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }"
        title="Ponovni vnos">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  }

  @if (showTooltipValue) {
    <span class="sem-text-box-tooltip">{{value}}</span>
  }

  <!-- *ngIf="!evaluateConditionForHiding(condition,model)" -->
  <p class="binding-prop-name">{{getAttribute('name')}}</p>

  <!--
  <p>{{value}}</p>
  <p>{{ model?.VehicleModel }}</p>
  <pre>{{ model | json }}</pre>
  -->
<!-- Record translations. Renders nothing unless the feature is on AND this field is declared
     translatable, so every other form is untouched. -->
<sem-translation-pills [fieldName]="getAttribute('name')"
  [disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true"></sem-translation-pills>
